import React from "react";
import ReactApexChart from "react-apexcharts";
import type { ApexOptions } from "apexcharts";
import type ApexCharts from "apexcharts";

/** Props alinhadas a react-apexcharts v2 (`chartRef`, não `ref`). */
export type SafeApexChartProps = {
  type?:
    | "line"
    | "area"
    | "bar"
    | "pie"
    | "donut"
    | "radialBar"
    | "scatter"
    | "bubble"
    | "heatmap"
    | "candlestick"
    | "boxPlot"
    | "radar"
    | "polarArea"
    | "rangeBar"
    | "rangeArea"
    | "treemap";
  series?: ApexOptions["series"];
  width?: string | number;
  height?: string | number;
  options?: ApexOptions;
  chartRef?: React.RefObject<ApexCharts | null>;
  className?: string;
  dir?: string;
};

/**
 * Gráficos de produto (Dashboard tenant/SA).
 * Por quê wrapper: pin visual de `react-apexcharts` ≥ 2.1.1 (try/catch no destroy).
 * Demos Velzon podem importar a lib direto; telas operacionais usam este módulo
 * (DOC 09 § 7.4). Em v2+ use `chartRef` — não `ref` do componente.
 */
const SafeApexChart = (props: SafeApexChartProps) => (
  <ReactApexChart {...props} />
);

export default SafeApexChart;
